<template>
<div class="like-rq flexbox">
    <div class="align-items-center">
        <a class="btn-like" :class="{ active : is_checked_liked == true, disabled: is_disabled_liked == true }" href="javascript:void(0)" @click="likeRequest(requestId);">
            <i class="far fa-heart" title="いいね!"></i>
            <span class="text-like">いいね!</span>
        </a>
        <span class="num-like" :class="{ active : is_checked_liked == true }">{{ count_like }}</span>
        <component :is="currentRole" ref="caution" />
    </div>
</div>
</template>
<style>
 .disabled{
   pointer-events:none;
 }
</style>
<script>
import axios from 'axios';
import CautionModal from './CautionModal.vue';
    export default {
        components: { CautionModal },
        data() {
          return {
            currentRole: 'CautionModal',
            mute: false,
            count_like : 0,
            is_checked_liked: false,
            is_disabled_liked: this.isDisabledLiked,
          }
        },
        methods: {
            init: function () {
                this.count_like = typeof(this.countLike) !== 'undefined' ? this.countLike : this.count_like;
                this.count_like = typeof(count_like) !== 'undefined' ? count_like : this.count_like;
                this.is_checked_liked = typeof(this.isCheckLiked) !== 'undefined' ? this.isCheckLiked : this.is_checked_liked;
                this.is_checked_liked = typeof(is_checked_liked) !== 'undefined' ? is_checked_liked : this.is_checked_liked;
            },
            likeRequest: function(request_id) {
                this.$refs.caution.loading(true);
                axios({
                        headers: { 'X-Requested-With': 'XMLHttpRequest' },
                        method: 'POST',
                        url: '/api/send-request-like/'+request_id,
                        params: { 'request_id': request_id },
                })
                .then(res => {
                        if (res.data.success == true)
                        {
                            this.is_checked_liked = this.is_checked_liked == true ? false : true;
                            this.count_like = this.is_checked_liked == true ? parseInt(this.count_like) + 1 : this.count_like - 1;
                        }
                        this.$refs.caution.loading(false);
                }).catch(err => {
                        console.error(err);
                        this.$refs.caution.setMessage(err.response.data.error,err.response.data.outputMessage);
                        this.$refs.caution.loading(false);
                })
            },
        },
        created() {
          this.init();
        },
        props: ['requestId','isCheckLiked', 'countLike','isDisabledLiked'],
    }
</script>
